
/**  @deprecated  ./animations.ts*/


import { animate, keyframes, state, style, transition, trigger } from "@angular/animations";

export const PecAnimations = {
  swingInTopFwd: trigger("swingInTopFwd", [
    state("up", style({ transformOrigin: "bottom" })),
    state("down", style({ transformOrigin: "top" })),

    transition("void => up", [
      style({ transform: "rotateX(100deg)", transformOrigin: "bottom", opacity: 0 }),
      animate("300ms ease-out", style({ transform: "rotateX(0deg)", opacity: 1 })),
    ]),

    transition("void => down", [
      style({ transform: "rotateX(-100deg)", transformOrigin: "top", opacity: 0 }),
      animate("300ms ease-out", style({ transform: "rotateX(0deg)", opacity: 1 })),
    ]),

    transition("up => void", [
      style({ transformOrigin: "bottom" }),
      animate("300ms ease-in", style({ transform: "rotateX(100deg)", opacity: 0 })),
    ]),

    transition("down => void", [
      style({ transformOrigin: "top" }),
      animate("300ms ease-in", style({ transform: "rotateX(-100deg)", opacity: 0 })),
    ]),
  ]),
  showOptions: trigger("showOptions", [
    state(
      "void",
      style({
        opacity: 0,
        transform: "scale(0.95)",
      })
    ),
    state(
      "*",
      style({
        opacity: 1,
        transform: "scale(1)",
      })
    ),
    transition("void => *", [animate("150ms ease-in-out")]),
    transition("* => void", [
      animate(
        "150ms ease-in-out",
        style({
          opacity: 0,
          transform: "scale(0.95)",
        })
      ),
    ]),
  ]),
  scaleUpCenter: trigger("scaleUpCenter", [
    transition(":enter", [
      animate(
        "0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000)",
        keyframes([style({ transform: "scale(0.1)", offset: 0 }), style({ transform: "scale(1)", offset: 1 })])
      ),
    ]),
    transition(":leave", [
      animate(
        "0.3s cubic-bezier(0.250, 0.460, 0.450, 0.940)",
        keyframes([style({ opacity: 1, offset: 0 }), style({ opacity: 0, offset: 1 })])
      ),
    ]),
  ]),
  verticalSlide: trigger("verticalSlide", [
    transition(":enter", [
      style({ height: "0px", opacity: 0, overflow: "hidden" }),
      animate("400ms ease-in-out", style({ height: "*", opacity: 1 })),
    ]),
    transition(":leave", [
      style({ height: "*", opacity: 1, overflow: "hidden" }),
      animate("400ms ease-in-out", style({ height: "0px", opacity: 0 })),
    ]),
  ]),
  hoverText: trigger("hoverText", [
    state(
      "normal",
      style({
        transform: "translateX(0)",
      })
    ),
    state(
      "hovered",
      style({
        transform: "translateX(7px)",
      })
    ),
    transition("normal <=> hovered", animate("300ms ease-in-out")),
  ]),
};
